<template>
  <OPanelLink
    :path="path"
  >
    <AttachmentEmbedContainer
      :title="data.form.title"
      :info="data.createdLabel"
      type="Form"
      icon="forms"
    />
  </OPanelLink>
</template>

<script setup lang="ts">
import AttachmentEmbedContainer from '../../embed/Container.vue'

import { CustomerForm } from '~/_api/models/customerForm'

interface Props {
  attachment: Record<string, any>
}

const props = defineProps<Props>()

const data = computed(() => new CustomerForm(props.attachment.object))

const isFormStateLocked = computed(() => data.value.isFormStateLocked)
const isRequestStateRequested = computed(() => data.value.isRequestStateRequested)
const isRequestStateScheduled = computed(() => data.value.isRequestStateScheduled)

const path = computed(() => {
  if (!isFormStateLocked.value) {
    return `/customer/form/${data.value.idCustomerForm}`
  }

  if (!isRequestStateRequested.value && !isRequestStateScheduled.value) {
    return `/customer/form/view?id=${data.value.idCustomerForm}`
  }

  return null
})
</script>
